/**
 * Zaman disiplini — DK-03 ve KK-406.
 *
 * İki ayrı sorun çözülür:
 *
 * 1) SUNUCU TARAFI: konteyner varsayılanı UTC'dir. "Gün sınırı 00:00 yerel saat"
 *    kuralı (KK-205) sistem saat dilimine güvenilerek uygulanamaz — okulun saat
 *    dilimi DB'den okunur ve tüm gün hesapları ona göre yapılır.
 *
 * 2) TERMİNAL TARAFI: kasa saati yanlış olabilir (risk tablosu: "Yüksek olasılık").
 *    Satış zaman damgası sunucu offset'i + performance.now() monotonik sayacından
 *    türetilir; ham sistem saatine güvenilmez.
 */
/** Verilen anın, belirtilen saat diliminde hangi takvim gününe düştüğü (YYYY-MM-DD). */
export function yerelGun(an, saatDilimi) {
    const bicimlendirici = new Intl.DateTimeFormat("en-CA", {
        timeZone: saatDilimi,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
    return bicimlendirici.format(an);
}
/**
 * Bir takvim gününün, verilen saat diliminde [baslangic, bitis) UTC aralığı.
 * Gün sınırı 00:00 yereldir (KK-205); yaz saati geçişlerinde de doğru çalışır
 * çünkü ofset günün kendisinden hesaplanır.
 */
export function gunAraligi(gun, saatDilimi) {
    const baslangic = yerelGeceYarisi(gun, saatDilimi);
    const ertesi = new Date(baslangic.getTime() + 26 * 3600_000);
    const ertesiGun = yerelGun(ertesi, saatDilimi);
    const bitis = yerelGeceYarisi(ertesiGun, saatDilimi);
    return { baslangic, bitis };
}
/** "YYYY-MM-DD" gününün yerel 00:00'ının UTC karşılığı. */
function yerelGeceYarisi(gun, saatDilimi) {
    const [y, a, g] = gun.split("-").map((p) => Number.parseInt(p, 10));
    if (y === undefined || a === undefined || g === undefined) {
        throw new Error(`Geçersiz gün biçimi: ${gun}`);
    }
    // Önce UTC olarak varsay, sonra hedef saat diliminin o andaki ofsetiyle düzelt.
    const varsayim = Date.UTC(y, a - 1, g, 0, 0, 0);
    const ofset1 = saatDilimiOfsetiMs(new Date(varsayim), saatDilimi);
    const aday = new Date(varsayim - ofset1);
    // DST sınırı için ikinci geçiş
    const ofset2 = saatDilimiOfsetiMs(aday, saatDilimi);
    return new Date(varsayim - ofset2);
}
/** Verilen anda saat diliminin UTC'ye göre ofseti (ms). */
export function saatDilimiOfsetiMs(an, saatDilimi) {
    const bicim = new Intl.DateTimeFormat("en-US", {
        timeZone: saatDilimi,
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
    const p = {};
    for (const parca of bicim.formatToParts(an)) {
        if (parca.type !== "literal")
            p[parca.type] = parca.value;
    }
    const saat = p.hour === "24" ? "00" : (p.hour ?? "00");
    const yerelMs = Date.UTC(Number.parseInt(p.year ?? "1970", 10), Number.parseInt(p.month ?? "01", 10) - 1, Number.parseInt(p.day ?? "01", 10), Number.parseInt(saat, 10), Number.parseInt(p.minute ?? "00", 10), Number.parseInt(p.second ?? "00", 10));
    return yerelMs - Math.floor(an.getTime() / 1000) * 1000;
}
/**
 * Terminal saati — KK-406.
 * Sunucu offset'i her senkronda güncellenir; okunan an her zaman
 * monotonik sayaçtan türetilir, böylece sistem saati geriye alınsa bile
 * ardışık satışların sırası bozulmaz.
 */
export class TerminalSaati {
    ofsetMs = 0;
    baslangicEpoch;
    baslangicPerf;
    perf;
    constructor(perfNow) {
        this.perf = perfNow ?? (() => Date.now());
        this.baslangicEpoch = Date.now();
        this.baslangicPerf = this.perf();
    }
    /** Her pull yanıtında çağrılır (§11.3). */
    ofsetiGuncelle(sunucuZamaniISO, istekBaslangicMs, gidisDonusMs) {
        const sunucu = Date.parse(sunucuZamaniISO);
        if (Number.isNaN(sunucu))
            return;
        this.ofsetMs = sunucu - (istekBaslangicMs + gidisDonusMs / 2);
    }
    simdi() {
        return new Date(this.baslangicEpoch + this.ofsetMs + (this.perf() - this.baslangicPerf));
    }
    get ofset() {
        return this.ofsetMs;
    }
    /** Sapma eşiği aşılırsa merkeze alarm gider (risk tablosu). */
    sapmaBuyukMu(esikMs = 120_000) {
        return Math.abs(this.ofsetMs) > esikMs;
    }
}
//# sourceMappingURL=zaman.js.map